export default {
    resizableSides: []
}
